module.exports = __webpack_public_path__ + "img/four_ball.597f90a9.png";